import React from 'react';
import { FormattedMessage } from 'react-intl';
import MediaQuery from 'react-responsive';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { SeCheckbox } from '../../components/ui/SeCheckbox';
import {
    MOBILE_BREAKPOINT_MAX,
} from '../../config/consts';
import styles from './index.module.scss';

import { ProductsParametersApi } from '@pes-ui/utils/lib/types/api/products-parameters-api';
import { MappedProduct } from '../../utils/mappers';

type Props = {
    products: MappedProduct[];
    categoryList: ProductsParametersApi.Sections[],
    highlightDifferencesChange: () => void,
    highlightDifferences: boolean,
    handleHideSimilarChange: () => void;
    hideSimilarFeatures: boolean;
    isMinified?: boolean;
    hideSimilaritiesCalculated?: boolean;
}

const OptionsCard: React.FC<Props> = ({
    products,
    highlightDifferencesChange,
    highlightDifferences,
    handleHideSimilarChange,
    hideSimilarFeatures,
    isMinified,
    categoryList,
}) => {
    const optionsCardClass = classNames({
        [styles.optionsCard]: true,
        [styles.optionsCard__minified]: isMinified,
    });

    const checkCategoriesOfProducts = (products: MappedProduct[]) => {
        return products.filter(product => !isEmpty(product.productCategories)).length;
    };

    const renderCheckBoxContainer = () =>
        products.length > 1 && checkCategoriesOfProducts(products) > 0 ? (
            <div className={styles.checkbox_container}>
                <SeCheckbox
                    onChange={handleHideSimilarChange}
                    checked={hideSimilarFeatures}
                    label="comparison.label.hideSimilarities"
                    defaultMessage="Hide Similarities"
                />
                <SeCheckbox
                    onChange={highlightDifferencesChange}
                    checked={highlightDifferences}
                    label="comparison.label.highlightDiff"
                    defaultMessage="Highlight Differences"
                />
            </div>
        ) : null;

    const categoryListIsEmpty = categoryList && categoryList.filter((item) => {
        return item.length > 0;
    });

    return (
        <div className={optionsCardClass}>
            <MediaQuery minDeviceWidth={MOBILE_BREAKPOINT_MAX}>
                <FormattedMessage id="comparison.label.items" defaultMessage={'Items'}>
                    {txt => (
                        <div className={styles.total}>
                            {txt}: {products.length}
                        </div>
                    )}
                </FormattedMessage>
            </MediaQuery>
            { categoryList && categoryListIsEmpty.length > 0 && renderCheckBoxContainer() }
        </div>
    );
};


export default OptionsCard;
